import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    getTopPicks,
    getAddOns,
    getMoreLike,
} from "../services/topPicks.service";

// 🔹 Thunks
export const fetchTopPicks = createAsyncThunk(
    "topPicks/fetchTopPicks",
    async (_, { rejectWithValue }) => {
        try {
            return await getTopPicks();
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const fetchAddOns = createAsyncThunk(
    "topPicks/fetchAddOns",
    async (_, { rejectWithValue }) => {
        try {
            return await getAddOns();
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

export const fetchMoreLike = createAsyncThunk(
    "topPicks/fetchMoreLike",
    async (_, { rejectWithValue }) => {
        try {
            return await getMoreLike();
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

const initialState = {
    items: [],
    addOns: [],
    moreLike: [],
    status: {
        topPicks: "idle",
        addOns: "idle",
        moreLike: "idle",
    },
    error: null,
};

const topPicksSlice = createSlice({
    name: "topPicks",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // 🔹 Top Picks
            .addCase(fetchTopPicks.pending, (state) => {
                state.status.topPicks = "loading";
            })
            .addCase(fetchTopPicks.fulfilled, (state, action) => {
                state.status.topPicks = "succeeded";
                state.items = action.payload || [];
            })
            .addCase(fetchTopPicks.rejected, (state, action) => {
                state.status.topPicks = "failed";
                state.error = action.payload;
            })

            // 🔹 Add Ons
            .addCase(fetchAddOns.pending, (state) => {
                state.status.addOns = "loading";
            })
            .addCase(fetchAddOns.fulfilled, (state, action) => {
                state.status.addOns = "succeeded";
                state.addOns = action.payload || [];
            })
            .addCase(fetchAddOns.rejected, (state, action) => {
                state.status.addOns = "failed";
                state.error = action.payload;
            })

            // 🔹 More Like
            .addCase(fetchMoreLike.pending, (state) => {
                state.status.moreLike = "loading";
            })
            .addCase(fetchMoreLike.fulfilled, (state, action) => {
                state.status.moreLike = "succeeded";
                state.moreLike = action.payload || [];
            })
            .addCase(fetchMoreLike.rejected, (state, action) => {
                state.status.moreLike = "failed";
                state.error = action.payload;
            });
    },
});

export default topPicksSlice.reducer;
